import ApiOff from './apioff'

/**
 * @type {ResetPassword}
 */
export default class ResetPassword extends ApiOff {

    /**
     * Solicita um token de autenticação para realizar a alteração de senha para um usuário
     *
     * @param {Object} data Objeto contendo os dados de e-mail de um usuário
     * @returns 
     */
    recover(data){
        return this.http.post('remember', data)
    }

    /**
     * Recebe o e-mail de um usuário e verifica se este existe e retorna o número de telefone
     * caso possua
     *
     * @param {Object} data Objeto contendo os dados de e-mail de um usuário
     * @returns 
     */
    checkEmail(data) {
        return this.http.post('checkemail', data)
    }

    /**
     * Valida o token de autenticação enviado via e-mail ou SMS para um usuário
     *
     * @param {String|Integer} userID ID de um usuário cadastrado
     * @param {String} token Token de autenticação enviado para o e-mail ou o telefone do usuário
     */
    checkToken(userID, token){
        return this.http.get(`remember/${userID}/${token}`)
    }

    /**
     * Realiza a alteração da senha de um usuário de acordo com a nova senha selecionada
     *
     * @param {String|Integer} userID ID do usuário que solicitou a alteração de senha
     * @param {String} token Token de autenticação enviado via e-mail ou SMS para o usuário
     * @param {Object} data Objeto contento a nova senha selecionada pelo usuário
     * @returns 
     */
    setPassword(userID, token, data){
        return this.http.post(`remember/${userID}/${token}`, data)
    }
}